if (!customElements.get('product-popup')) {
  class ProductPopup extends HTMLElement {
    constructor() {
      super();
    }

    toggleContent(shouldOpen) {
      this.classList.toggle('is-open', shouldOpen);
      shouldOpen
        ? bodyScroll.lock(this.content)
        : bodyScroll.unlock(this.content);
    }

    checkTables() {
      this.tables.forEach((table) => {
        table.parentElement.classList.toggle(
          'has-overflow',
          table.clientWidth > this.contentInner.clientWidth
        );
      });
    }

    connectedCallback() {
      this.opener = this.querySelector('.js-popup-opener');
      this.close = this.querySelectorAll('.js-popup-close');
      this.content = this.querySelector('.js-popup-content');

      if (!this.opener || !this.content) return;

      this.opener.addEventListener('click', (event) => {
        event.preventDefault();

        this.toggleContent(true);
      });

      this.close.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();

          this.toggleContent(false);
        });
      });

      this.tables = this.content.querySelectorAll('table');
      this.contentInner = this.content.querySelector(
        '.js-content-inner'
      );

      if (!this.tables.length || !this.contentInner) return;

      this.checkTables();

      window.addEventListener('resize', () => {
        this.checkTables();
      });
    }
  }
  customElements.define('product-popup', ProductPopup);
}
